// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f4b21e71","769":"90b4b021"}[chunkId] + ".chunk.js";
};